var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReservationBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.96 55.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#263d50;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Id\\u0151pontfoglal\\xE1s"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "28.62 9.39 24.91 9.39 16.59 9.39 8.27 9.39 1 9.39 1 18.99 3.63 18.99 28.62 18.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.62,19h-25v30.1a5.31,5.31,0,0,0,5.3,5.3H40.71a5.3,5.3,0,0,0,5.3-5.3V36.68"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.74,
    y1: 27.86,
    x2: 15.72,
    y2: 27.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 8.27,
    y1: 6.41,
    x2: 8.27,
    y2: 9.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 16.59,
    y1: 6.41,
    x2: 16.59,
    y2: 9.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 24.91,
    y1: 6.41,
    x2: 24.91,
    y2: 9.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 22.73,
    y1: 27.86,
    x2: 25.71,
    y2: 27.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.74,
    y1: 36.69,
    x2: 15.72,
    y2: 36.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 22.73,
    y1: 36.69,
    x2: 25.71,
    y2: 36.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 32.73,
    y1: 36.69,
    x2: 35.71,
    y2: 36.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.74,
    y1: 45.3,
    x2: 15.72,
    y2: 45.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 22.73,
    y1: 45.3,
    x2: 25.71,
    y2: 45.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 32.73,
    y1: 45.3,
    x2: 35.71,
    y2: 45.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 46.28,
    cy: 18.48,
    r: 14.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 41.81,
    y1: 1,
    x2: 51.41,
    y2: 1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 46.28,
    y1: 11.54,
    x2: 46.28,
    y2: 18.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 46.28,
    y1: 18.48,
    x2: 50.53,
    y2: 21.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 57.22,
    y1: 18.7,
    x2: 61,
    y2: 18.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 31.6,
    y1: 18.7,
    x2: 35.38,
    y2: 18.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 46.28,
    y1: 7.56,
    x2: 46.28,
    y2: 3.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 46.28,
    y1: 33.18,
    x2: 46.28,
    y2: 29.4
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservationBlack);
export default __webpack_public_path__ + "static/media/reservationBlack.67a6715d43d4674099cb68ccb5f188dd.svg";
export { ForwardRef as ReactComponent };